import dayjs from 'dayjs';

export const RESOLUTION_YEAR_MIN = 1950;

const startOfDayMs = (value: dayjs.Dayjs) =>
  value.hour(0).minute(0).second(0).millisecond(0).toDate().getTime();

export const getResolutionYearOptions = () => {
  const currentYear = dayjs().year();
  const years: Array<number> = [];

  for (let year = currentYear; year >= RESOLUTION_YEAR_MIN; year -= 1) {
    years.push(year);
  }

  return years;
};

export const getResolutionDateForStartYear = (year: number) =>
  startOfDayMs(dayjs().year(year).startOf('year'));

export const getResolutionDateForEndYear = (year: number) =>
  startOfDayMs(dayjs().year(year).endOf('year'));

export const getYearFromResolutionDate = (
  value?: number | Date | null,
): number | '' => {
  if (value == null) {
    return '';
  }

  const year = dayjs(value).year();

  return Number.isFinite(year) ? year : '';
};
